module.exports = __webpack_public_path__ + "img/fushimi-HP-005.9757ad7c.jpg";